import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article11() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });




  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';

      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
    // Call your function here
    setTimeout(() => {
      navigate('/article12');

    }, 1000); // Delay of 2000 milliseconds (2 seconds)

  };

  const handleClick1 = () => {
    setAddClass(true);
    // Call your function here
    setTimeout(() => {
      navigate('/article10');

    }, 1000); // Delay of 2000 milliseconds (2 seconds)

  };

  const handleClick2 = () => {
    setAddClass(true);
    // Call your function here
    setTimeout(() => {
      navigate('/');

    }, 1000); // Delay of 2000 milliseconds (2 seconds)

  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article11-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article11-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <div className="row mb-4">
                <div className="col-auto">
                  <img src={require("../../Images/article11-right-img1.jpg")} />
                </div>
                <div className="col">
                  <h3 className="text-gold fs-md">Folklore,
                  <br/>Myths &
                  <br/>Legends</h3>
                </div>
              </div>
              
              <h1 className="fs-xl f-lora mb-2">The FIDDLERS <br/>of TOMNAHURICH </h1>
              <hr className="text-gold my-4" />
              <p className="f-lora-i lh-base mb-4 mb-sm-5 text-gold" variants={textAnimate}>Scotland has a long tradition of storytelling and superstition. Every community has a local tale of folklore, from haunted houses to monsters in the loch. In Inverness, everybody knew that Tomnahurich was a fairy hill. Everybody apart from two travelling fiddle players who arrived in town looking to make some money.</p>

              <div className="row mb-4 mb-sm-5">
                <div variants={textAnimate} className="col-sm-6">
                  <p className="" variants={textAnimate}>They had passed through dozens of towns and villages by the time they arrived in Inverness but without much success. The fiddlers busked on the street, playing reels, jigs and laments to get some attention, but the passersby weren’t impressed. None looked their way, apart from one old man. </p>
                  <p className="" variants={textAnimate}>He grinned as he watched, tapping away to the beat. Eventually, he walked up to the dejected fiddlers and made them an offer they couldn’t refuse. </p>
                  <p className="" variants={textAnimate}>A remarkable group of people were looking for some remarkable musicians to play that evening. They would pay double the usual rate and even feed them as well! All they had to do was meet him at Tomnahurich Hill at sunset. </p>
                </div>
                <div variants={textAnimate} className="col-sm-6">
                  <p className="" variants={textAnimate}>That sounded like an excellent proposition, but was it too good to be true? The pair had barely eaten for days so it didn’t take long to accept the offer. Just as the sun was going down, they marched to Tomnahurich and found the old man waiting. </p>
                  <p className="" variants={textAnimate}>He showed them into a strange opening in the hillside where light, warmth and laughter blared out. An enormous hall stretched before them, full of people dressed in the finest of clothes around a table groaning under the weight of food. </p>
                  <p className="" variants={textAnimate}>A loud cheer came at the sound of the two musicians tuning their instruments before announcing the first song. The party was wild as the fairies danced, everybody feasted and the fiddlers of Tomnahurich </p>
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div variants={textAnimate} className="col-sm-6">
                  <p className="" variants={textAnimate}>had just as much fun as their audience. They didn’t think they had ever played so well and were certainly earning their extra payment! </p>
                  <p className="" variants={textAnimate}>But all good things must come to an end. When the dances were finished, the old man paid the two fiddlers and ushered them out into the early dawn. One of the pair turned to ask if they would be needed again, but the door in the side of the hill had disappeared. </p>
                  <p className="" variants={textAnimate}>The men slowly walked into Inverness, tired from their night’s work, but everything seemed different. Houses had sprung up where there were only fields before and they didn’t recognise any of the stores or pubs. All the people were dressed strangely, although they were the ones whispering and pointing at the fiddler’s clothes! </p>
                </div>
                <div variants={textAnimate} className="col-sm-6">
                  <p className="" variants={textAnimate}>A church bell rang out loud. Finally, something they recognised and maybe somewhere they could get a little sense from. The pair headed straight to the Sunday service and sat at the back. Soon, the minister started the sermon but the second he mentioned the Lord’s name, the fiddlers crumbled into dust. </p>
                  <p className="" variants={textAnimate}>It turned out that they hadn’t been playing under the hill for a single night. They had been inside Tomnahurich for 100 years and that whole century caught up with them in an instant. That’s why local traditions are so important, they might save you from accepting a dangerous invite to the fairies’ party! </p>
                </div>
              </div>



            </div>
          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article11;
